(function() {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;

    const applySlider = () => {
        const slider = document.querySelector('salepify-ymal .salepify-ymal__body');
        if (!slider) return;

        if (slider.dataset.dragApplied) return;
        slider.dataset.dragApplied = "true";

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            startX = e.pageX;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            setTimeout(() => (isDragging = false), 0);
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;

            const dx = e.pageX - startX;

            if (Math.abs(dx) > 0) {
                isDragging = true;
            }

            slider.scrollLeft = scrollLeft - dx;
        });

        slider.addEventListener('dragstart', (e) => {
            e.preventDefault();
        });

        slider.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault();
                }
            });
        });
    }

    let tlYMALClone;

    Object.defineProperty(window, "tlYMAL", {
        get() {
            return tlYMALClone;
        },
        set(val) {
            if (val && !tlYMALClone) {
                tlYMALClone = val;

                val.refreshCartContent = async () => {
                    try {
                        const cartItemsEl = document.querySelector("cart-items");
                        if (!cartItemsEl) return;

                        const sectionId = FoxTheme.utils.getSectionId(cartItemsEl);

                        const [sectionHTML, cartData] = await Promise.all([
                            fetch(`${window.Shopify.routes.root}?section_id=${sectionId}`).then((res) => res.text()),
                            fetch("/cart.js").then((res) => res.json()),
                        ]);

                        cartData.sections = { [sectionId]: sectionHTML };
                        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartData });

                        window.tlCartGoalEmbed.renderAllCartGoals();
                        if (needInitialize) {
                            window.tlCartGoalEmbed.initializeLocalStorage();
                        }

                        return;
                    } catch (error) {
                        console.error("Error re-render theme Sleek, Hyper:", error);
                    }
                }

                val.getCartAndCartDrawerSelector = () => {
                    const url = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
                    let rootSelector = `
                        form[action="${url}cart"]:not(#cart.cart.form.cart--with-items.gap-theme.heading--text-start),
                        .mini-cart-content,tt-desctop-parent-cart > .tt-dropdown-menu, form[action*="/cart"]#updateform,
                        cart-drawer.drawer.drawer--cart > .drawer__content > .drawer__header,
                        #cart.cart.form.cart--with-items.gap-theme.heading--text-start > .cart__summary,
                        .tt-dropdown-menu > .tt-dropdown-inner .tt-cart-box .tt-cart-list,
                        form[action*="/cart?locale"]#CartDrawer-Form, form[action*="/cart?locale"]#cart,
                        form[action*="${url}cart"]:not([action*="/cart/add"])
                    `;
                    const themeName = window?.Shopify?.theme?.schema_name ?? "";
                    const isCartPage = window.tlYMAL.template == "cart";

                    if (isCartPage) return rootSelector;
                    return 'cart-drawer .drawer__inner .drawer__content[id], #CartDrawer cart-items';
                }

                val.insertWidget = () => {
                    const position = window.tlYMAL.displaySettings.position == window.tlYMAL.POSITION_OF_YMAL.TOP
                        ? "beforebegin" : "afterend";

                    window.tlYMAL.targetElements.forEach((target) => {
                        target.insertAdjacentHTML(position, `<salepify-ymal></salepify-ymal>`)
                    });

                    setTimeout(applySlider, 1000);
                }

                val.reInsertWidget = () => {
                    if (!window.tlYMAL.displayRule) return;

                    const position = window.tlYMAL.displaySettings.position == window.tlYMAL.POSITION_OF_YMAL.TOP
                        ? "beforebegin" : "afterend";

                    document.querySelectorAll("salepify-ymal").forEach(ele => ele.destroy());

                    window.tlYMAL.targetElements = window.tlYMAL.getTargetElements();

                    window.tlYMAL.targetElements.forEach((target) => {
                        target.insertAdjacentHTML(position, `<salepify-ymal rule-id=${window.tlYMAL.displayRule.id}></salepify-ymal>`);
                    });

                    setTimeout(applySlider, 1000);
                }
            }
        },
        configurable: true
    });
})();